module.exports = __webpack_public_path__ + "assets/huiyiguanli.97f90d35.svg";